import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CircularProgress from 'apollo-react/components/CircularProgress';
import Divider from 'apollo-react/components/Divider';
import VerticalPrimeTable from '../../common/DataTable/verticalPrimeTable';
import SubformPreview from '../../common/SubformPreview/SubformPreview';
import LinkedItemsList from '../../common/LinkedItemsList/LinkedItemsList';
import useSubformPreview from '../../../hooks/features/subforms/useSubformPreview';
import styles from './SubFormDetails.module.css';

const SubFormDetails = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { subform, schema, linkedForms, loading } = useSubformPreview(id);

  if (loading || !subform) {
    return (
      <div className={styles.loadingContainer}>
        <CircularProgress />
      </div>
    );
  }

  const metadata = {
    name: subform.name,
    description: subform.description,
    createdAt: subform.createdAt,
    updatedAt: subform.updatedAt,
    createdBy: subform.User?.username,
  };

  return (
    <div className={styles.container}>
      <VerticalPrimeTable data={metadata} />

      <Divider />

      <div className={styles.section}>
        <LinkedItemsList
          items={linkedForms}
          titleKey="linked_forms"
          emptyKey="no_linked_forms"
          linkPrefix="forms"
        />
      </div>

      <Divider />

      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('subform_preview')}</h3>
        <SubformPreview schema={schema} />
      </div>
    </div>
  );
};

export default SubFormDetails;
